import React from "react";
import landingImg from "../assets/landingImage.png";

function Landing() {
  return (
    <section>
      <div className="mx-auto max-w-7xl flex justify-between flex-col">
        <div className="mt-10 max-w-2xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
          <div className="lg:text-left">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl">
              <span className="block xl:inline">
                Packing and moving made easy.
              </span>
            </h1>
            <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:max-w-xl sm:text-lg md:mt-5 md:text-xl lg:mx-0">
              Brothers Packers Movers is one of the leading companies providing
              trustworthy, committed, and end-to-end logistic solutions to the
              customers.
            </p>
            <div className="mt-5 sm:mt-8 sm:flex justify-start">
              <div className="rounded-md shadow">
                <a
                  href="#"
                  className="flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 md:py-4 md:px-10 md:text-lg"
                >
                  Explore Services
                </a>
              </div>
              <div className="mt-3 sm:mt-0">
                <a
                  href="#"
                  className="flex sm:ml-3 w-full items-center justify-center rounded-md border border-transparent bg-indigo-100 px-8 py-3 text-base font-medium text-indigo-700 hover:bg-indigo-200 md:py-4 md:px-10 md:text-lg"
                >
                  Contact
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 xl:mt-0 flex justify-end align-middle">
          <img
            src={landingImg}
            alt="landing"
            className="object-cover object-center xl:absolute right-0 top-36 mr-0 max-w-3xl w-full"
          />
        </div>
      </div>
    </section>
  );
}

export default Landing;
